
// import React from 'react'

// const PaymentFailure = () => {
//   return (
//     <div>
//       payment falure
//     </div>
//   )
// }

// export default PaymentFailure

const PaymentFailure = () => <div className="p-8 text-red-500">Payment Failed. Please try again.</div>;
export default PaymentFailure;
